<template>
  <div class="content">
    <img :src="apiData.banner.data"
         style="display: block;">
    <breadcrumbPage :search-tag="false"
                    :bg-color="'#fff'"></breadcrumbPage>
    <div class="bgBar">
      <div class="EC_width display_between">
        <img :src="apiData.intro.data.img">
        <div class="flex1 marginLeft30">
          <p style="line-height: 30px;">
            <span :class="{fontBold:item.fontBold}"
                  v-for="(item,index) in apiData.intro.data.context"
                  :key="'0'+index">
              {{item.text}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="EC_width display_flex marginTop20">
      <div class="leftContent flex1">
        <div class="gl_listWrapBar"
             v-for="(item,index) in apiData.list.data"
             :key="'0'+index">
          <div class="gl_imgList">
            <img :src="item.img">
          </div>
          <a href="javascript:;"
             class="gl_listItem">
            <div class="gl_listItemTitle">
              {{item.title}}
            </div>
            <div class="gl_listItemSub">
              {{item.titleSub}}
            </div>
            <div class="display_between marginTop10">
              <div>
                <span class="gl_gree_block"
                      v-for="(itemN,index2) in item.sign"
                      :key="'0'+index2">{{itemN}}</span>
              </div>
              <div class="gl_inforshow">
                <span class="marginRight20">{{item.date}}</span>
                <span><img src="/image/index/chakan.png"
                       class="marginRight5">{{item.browseNum}}</span>
              </div>
            </div>
          </a>
        </div>
        <!-- 分页器 -->
        <div class="pagination_Wrap">
          <ul class="pagination_normal">
            <li class="page_item_normal"><a class="page_link_normal"
                 href="javascript:;"
                 @click="firstPage">首页</a></li>
            <li class="page_item_normal"><a class="page_link_normal"
                 href="javascript:;"
                 @click="prePage">上一页</a></li>
            <li class="page_item_normal"
                :class="{page_active:pageIndex==item}"
                v-for="(item,index) in pageAll"
                :key="'0'+index"><a class="page_link_normal"
                 @click="pageSet(item)"
                 href="javascript:;">{{item}}</a></li>
            <li class="page_item_normal"><a class="page_link_normal"
                 href="javascript:;"
                 @click="nextPage">下一页</a></li>
            <li class="page_item_normal"><a class="page_link_normal"
                 href="javascript:;"
                 @click="lastPage">尾页</a></li>
          </ul>
        </div>
      </div>
      <div class="rightContent marginLeft40">
        <div class="gl_title_bar marginBottom20">
          <div class="gl_tb_left">
            <span class="normaltitle">更多专题</span>
          </div>
          <div class="gl_tb_right">
            <a href="javascript:;"
               class="gl_tb_right_more"><img src="/image/index/moreimg.png"
                   class="gltb_moreimg">更多</a>
          </div>
        </div>
        <div class="video_block"
             v-for="(item,index) in apiData.moreSpecial.data"
             :key="'0'+index">
          <img :src="item.img">
          <div class="video_title">
            {{item.title}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from "../home/breadcrumbPage"
export default {
  name: "specialHome2",
  data () {
    return {
      // 页数激活index
      pageIndex: 1,
      pageAll: 8,
      apiData: {
        "banner": {},
        "intro": {},
        "special": {},
        "moreSpecial": {}
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    // 首页
    firstPage () {
      this.pageIndex = 1
    },
    // 尾页
    lastPage () {
      this.pageIndex = this.pageAll
    },
    // 页数点击
    pageSet (index) {
      this.pageIndex = index
    },
    // 上一页
    prePage () {
      if (this.pageIndex > 1) {
        this.pageIndex--
      }

    },
    // 下一页
    nextPage () {
      if (this.pageIndex < this.pageAll) {
        this.pageIndex++
      }
    },
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.specialHome2.data
      })
    }
  },
  components: {
    breadcrumbPage
  },
}
</script>

<style scoped>
.content {
    flex: 1;
}
.bgBar {
    background: #f5f7fa;
    padding: 40px 0;
}
</style>
